import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchYearRecap } from '../../actions/creators/yearRecap';
import { Slide1 } from './slides/slide-1';
import { Slide2 } from './slides/slide-2';
import { Slide3 } from './slides/slide-3';
import { Slide4 } from './slides/slide-4';
import { Slide5 } from './slides/slide-5';
import { Slide6 } from './slides/slide-6';
import { getYearRecapData, isYearRecapLoading } from '../../reducers/yearRecap';
import Story from './Story';
import { getUserInfo } from '../../reducers';
import LogoLoading from '../LogoLoading';
import SlideNoRecap from './slides/SlideNoRecap';
import RequireAuthMessage from '../user/RequireAuthMessage';
import { asset } from '../../utils/misc';

export interface YearRecapData {
    has_recap: boolean;
    movies_watched: number;
    tickets_bought: number;
    hours_spent: number;
    fav_genre: string;
    popcorn_amount: number;
    concept: string;
    points_earned: number;
    points_redeemed: number;
    level_up: boolean;
    gift_codes: [
        { code: string; platinum: boolean },
        { code: string; platinum: boolean },
    ];
    fav_snack: string;
    fav_benefit: string;
    loyalty_level: string;
    fav_platform: string;
    birthday_combo_redeemed: boolean;
    birthday_month: string;
}

export interface SlideProps {
    current?: boolean;
    scale?: number;
    soundEnabled?: boolean;
    data?: YearRecapData | null;
}

const slides = [
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6,
];

export const isRecapInMobileApp = (): boolean => {
    return !!document.location.search.match(/\bfrom_app=1\b/);
};

interface RecapProps {
    data: YearRecapData | null;
    isLoading: boolean;
    user: any;
    fetchYearRecap: () => void;
}

function preloadImages(onAllImagesLoaded: () => void) {
    const images = [
        '/dist/images/year-recap/logo.png',
        '/dist/images/year-recap/drink.png',
        '/dist/images/year-recap/popcorn_bucket.png',
        '/dist/images/year-recap/seat.png',
        '/dist/images/year-recap/seat-lights.png',
        '/dist/images/year-recap/megaphone.png',
        '/dist/images/year-recap/popcorn_bucket_2.png',
        '/dist/audio/recap-music-01.mp3',
        '/dist/audio/recap-music-02.mp3',
        '/dist/audio/recap-music-03.mp3',
        '/dist/audio/recap-music-04.mp3',
        '/dist/audio/recap-music-05.mp3',
        '/dist/audio/recap-music-06.mp3',
        '/dist/audio/pop-01.mp3',
        '/dist/audio/pop-02.mp3',
        '/dist/audio/popcorn-pop.mp3',
        '/dist/audio/swoosh-06.mp3',
        '/dist/audio/typewriter.mp3',
    ];

    for (let i = 1; i <= 7; i++) {
        images.push(`/dist/images/year-recap/popcorn_${i}.png`);
    }

    images.forEach((src) => {
        const img = new Image();
        img.src = asset(src);
    });
    let loadedCount = 0;
    const totalImages = images.length;
    
    images.forEach((src) => {
        const isAudio = src.substring(src.length - 4) === '.mp3';
        const img = isAudio ? new Audio() : new Image();
        img.src = asset(src);
        img[isAudio ? 'oncanplaythrough' : 'onload'] = () => {
            loadedCount += 1;
            if (loadedCount === totalImages) {
                onAllImagesLoaded();
            }
        };
        img.onerror = () => {
            loadedCount += 1;
            if (loadedCount === totalImages) {
                onAllImagesLoaded();
            }
        };
    });
}

const Recap: React.FC<RecapProps> = ({ data, isLoading, user, fetchYearRecap }) => {
    const [allImagesLoaded, setAllImagesLoaded] = React.useState(false);

    useEffect(() => {
        if (user) {
            fetchYearRecap();
        }
    }, [fetchYearRecap, user]);

    useEffect(() => {
        if (!data) return;
        
        // if (!data.has_recap) {
            setAllImagesLoaded(true);
        // } else {
        //     preloadImages(() => {
        //         setAllImagesLoaded(true);
        //     });
        // }
    }, [data]);

    const onClose = () => {
        if (isRecapInMobileApp()) {
            document.location = 'cinemex://com.cinemex/year-recap/close';
        } else {
            document.location = '/';
        }
    };

    if (!user) {
        return <RequireAuthMessage />;
    }
    
    if (!user.iecode) {
        document.location = '/';
        return null;
    }

    if (!data || !allImagesLoaded || isLoading) {
        return (
            <LogoLoading />
        );
    }

    return (
        <>
            <Story
                data={data}
                slides={(data && !data.has_recap) ? [SlideNoRecap] : slides}
                onClose={onClose}
            />
        </>
    );
};

const mapStateToProps = (state: any) => ({
    data: getYearRecapData(state),
    isLoading: isYearRecapLoading(state),
    user: getUserInfo(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchYearRecap: () => dispatch(fetchYearRecap()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Recap);